export default __webpack_public_path__ + "static/media/donut-reddit.ce393697.png";